<template>
  <div>
    <v-container>
      <h1 class="text-h4 light--text font-weight-light">Success.</h1>
      <h1 class="text-h5 light--text font-weight-light">
        We have received your information.
      </h1>
      <h1 class="text-h6 lightGreen--text font-weight-light">
        Thank you for choosing Ubiquity Internet.
      </h1>
    </v-container>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>